module.exports = __webpack_public_path__ + "img/new_05_workshop_4.79b3d794.jpg";